app.component('foodbalanceBasiccheck', {
	templateUrl: 'app/foodbalance/basiccheck.html',
	controller: function ($location, $scope, $route, foodPhotoAnalysis) {
        var $ctrl = this;
        $ctrl.$onInit = function () {
            // 画像ファイルを選ぶまで、画像解析ボタンを非表示にしておくためのフラグ
			$ctrl.selectImageFlg = false;
            // 解析結果領域
            $ctrl.endAnalysisFlg = false;
            $ctrl.endFeedbackFlg = false;
            $ctrl.AnalysisResultIsOpen = false;
            $ctrl.dataSelect = {
                'maindish' : '0',
                'meet'     : '0',
                'egg'      : '0',
                'fish'     : '0',
                'beans'    : '0',
                'sub'      : '0',
                'soup'     : '0',
                'fruits'   : '0',
                'milk'     : '0'
            };
            /* 解析結果 開閉切り替え */
            $ctrl.analysisResult_toggle = function() {
                if($ctrl.AnalysisResultIsOpen) {
                    $ctrl.AnalysisResultIsOpen = false;
                }
                else {
                    $ctrl.AnalysisResultIsOpen = true;
                }
            }
            $scope.$on( "photoAnalysisCompleted" , function (event, data) {
                $ctrl.dataSelect = data.dataSelect;
                $ctrl.analysisResultDetailNames = data.analysisResultDetailNames;
                $ctrl.analysisResultDetailValues = data.analysisResultDetailValues;
                $ctrl.analysisResultDetailIds = data.analysisResultDetailIds;
            });
            //「やりなおす」ボタンクリック
			$ctrl.redo = function () {
				$route.reload();
            }
            //「フィードバック」ボタンクリック
            $ctrl.feedback = function() {
                foodPhotoAnalysis.do_feefBack($ctrl.analysisResultDetailNames).then(function(response) {
                    $ctrl.endAnalysisFlg = false;
                    $ctrl.endFeedbackFlg = true;
                });
            }
            //「ワトソンに聞く」ボタンクリック
			$ctrl.watson = function () {
				$location.path("/foodbalance_watson");
			}
        };
	}
});

app.component('uploadPhotoForm', {
    template:
        '<style>'+
        '.form_file form { position:relative; height:100%; }'+
        '.form_file input[type=file] { visibility: hidden; width:100%; }'+
        '.form_file { width: 295px; height: 150px; margin: 10px auto; border: 2px dashed #555; }'+
        '.form_file img { margin: auto auto;position: absolute;top: 0px;left:0px;right:0px;bottom:0px;max-width:290px;max-height:140px;}'+
        '.bcbutton { width: 296px; color:#ffffff !important; }'+
        '</style>'+
        '<div layout="column" layout-align="center center">'+
        '<section class="form_file">'+
        '<form id="form" enctype="multipart/form-data">'+
        '<input type="file" id="form_file" name="file" file-model="imageFile" accept="image/*"/>'+
        '<div style="position:absolute;top:0px;height:100%;width:100%;">'+
        '<img id="previewImg" ng-if="$ctrl.imageFileSrc" ng-src="{{$ctrl.imageFileSrc}}" alt="{{$ctrl.imgalt}}"/>'+
        '</div>'+
        '</form>'+
        '</section>'+
        '<md-button class="md-primary md-raised bcbutton" ng-hide="$ctrl.selectImageFlg" ng-click="$ctrl.photoOpenDialog();">'+
        'ファイルを選択'+
        '</md-button>'
    ,
	controller: function ($http, $scope, $timeout, imageUtilService) {
        var $ctrl = this;
        $ctrl.selectImageFlg = false;
        $ctrl.photoOpenDialog = function() {
            $timeout(function() {
                document.getElementById("form_file").click();
            }, 0);
        };
        $scope.$watch("imageFile", function (imageFile) {
            $ctrl.imageFileSrc = undefined;
            if (!imageFile) {
                return;
            }
            if (!imageFile.type.match("image.*")) {
                alert("画像ファイルを選択してください！");
                $ctrl.selectImageFlg = false;
                return;
            }
            // ファイル名をalt属性にいれておく。
            $ctrl.imgalt = imageFile.name;
            var reader = new FileReader();
            reader.onload = function () {
                // 画像のexif情報からorientation値を取得
                var orientation = imageUtilService.getOrientation(reader.result);
                // 画像を圧縮し、orientation値から画像を補正する
                imageUtilService.getCompressedImage(reader.result, 0.3, orientation).then(function (response) {
                    // 圧縮、補正後の画像をビューへ反映
                    $timeout(function () {
                        $ctrl.imageFileSrc = response;
                        // img要素のsrc属性にbase64形式のデータが入っているか？
                        // bae64形式ではない場合は、画像は未更新扱いとする
                        var imgdata = "";
                        if ($ctrl.imgalt != ".") {
                            imgdata = $ctrl.imageFileSrc;
                        }
                        //postパラメータ
                        var imageTime = moment().format("YYYYMMDD") + moment().format("HHmmss");
                        var imageEntry = moment().format("YYYY-MM-DD") + " " + moment().format("HH:mm:ss");
                        var params = {
                            "image_name": $ctrl.imgalt.split(".")[0],
                            "image_data": imgdata,
                            "imagegroup": "balance",
                            "imagetime": imageTime,
                            "imageentry": imageEntry,
                            "user" : 9999,
                        };
                        // 画像をサーバへ送信
                        $http.post("/freeLiR/api/addImagefile.php", JSON.stringify(params)).then(function(response) {
                            $ctrl.imageFileSrc = response.data.ret;
                        });
                        // 画像解析ボタン表示する。
                        $ctrl.selectImageFlg = true;
                    }, 0);
                });
            };
            reader.readAsDataURL(imageFile);
        });
    },
    bindings: {
        "selectImageFlg" : "=",
        "imageFileSrc" : "="
    }
});

app.component('photoAnalysisButton', {
    template:
    '<style>.bcbutton { width: 296px; color:#ffffff !important; }</style>'+
    '<md-button class="md-primary md-raised bcbutton" ng-click="$ctrl.recognition()">'+
    '食事写真を解析する'+
    '</md-button>'
    ,
	controller: function ( foodPhotoAnalysis, $scope ) {
        var $ctrl = this;
        var _dataSelect = {
            'maindish' : '0',
            'meet'     : '0',
            'egg'      : '0',
            'fish'     : '0',
            'beans'    : '0',
            'sub'      : '0',
            'soup'     : '0',
            'fruits'   : '0',
            'milk'     : '0'
        };
        //「食事写真を解析する」ボタンクリック
        $ctrl.recognition = function () {
            $ctrl.endAnalysisFlg = false;
            $ctrl.endFeedbackFlg = false;
            // 食事写真の解析開始
            foodPhotoAnalysis.do_photoAnalysis($ctrl.imageFileSrc).then(function(result) {
                // 解析結果を画面へ反映
                angular.forEach(result.foodlist, function(value, key) {
                    for (var i = 0; i < value.length; i++) {
                        if (result.words.search(value[i]) != -1) {
                            _dataSelect[key] = '1';
                            break;
                        }
                    }
                });
                _dataSelect.sub = parseInt( _dataSelect.sub ); 
                // 食事画像の分析結果（解析結果のname、value値をセット）
                var _analysisResultDetailNames = [];
                var _analysisResultDetailValues = [];
                var _analysisResultDetailIds = [];
                for (var i = 0; i < result.detail.length; i++) {
                    _analysisResultDetailNames[i] = angular.copy( result.detail[i].name );
                    _analysisResultDetailValues[ result.detail[i].name ] = angular.copy( result.detail[i].value );
                    _analysisResultDetailIds[ result.detail[i].name ] = angular.copy( result.detail[i].id );
                }
                $ctrl.endAnalysisFlg = true;
                var rd = {
                    "dataSelect" : _dataSelect,
                    "analysisResultDetailNames" : _analysisResultDetailNames,
                    "analysisResultDetailValues" : _analysisResultDetailValues,
                    "analysisResultDetailIds" : _analysisResultDetailIds
                }
                $scope.$emit( "photoAnalysisCompleted", rd );
            });
        }
    },
    bindings: {
        "endAnalysisFlg" : "=",
        "endFeedbackFlg" : "=",
        "imageFileSrc" : "<",
    }
});

app.component('balanceJudgeButton', {
    template:
        '<style>.bcbutton { width: 296px; color:#ffffff !important; }</style>'+
        '<md-button class="md-primary md-raised bcbutton" ng-click="$ctrl.judge()">'+
        '診断する'+
        '</md-button>'
    ,
	controller: function ( $location, sharedDataRegionService, odmRecommendService ) {
        var $ctrl = this;
        //「診断」ボタンクリック
        $ctrl.judge = function () {
            var param0 = parseInt($ctrl.selectData.maindish);
            var param1 = parseInt($ctrl.selectData.meet) + parseInt($ctrl.selectData.egg) + parseInt($ctrl.selectData.fish) + parseInt($ctrl.selectData.beans);
            var param2 = parseInt($ctrl.selectData.sub);
            // 診断開始
            odmRecommendService.getbalancefoodRecommend(param0, param1, param2).then(function (response) {
                var recommend_info = response.data;
                var message = recommend_info["message"];
                var score = parseInt(recommend_info["score"]);
                if ($ctrl.selectData.soup == "1") {
                    score += 15;
                }
                else {
                    if ($ctrl.selectData.fruits == "1" || $ctrl.selectData.milk == "1") {
                        score += 10;
                    }
                }
                // 次の画面用にsharedDataRegionServiceに結果を保持
                sharedDataRegionService.setBalanceOdmResult(score, message, $ctrl.imageFileSrc);
                $location.path("/foodbalance_result");
            },
            function(error) {
                alert(error);
            });
        };
    },
    bindings: {
        "selectData" : "<",
        "imageFileSrc" : "<"
    }
});
